import { formatDateHyphenated } from "../../utils/dateFormat";

// Per-branch upload templates (ezp_expense_centers.upload_template). Mirrors
// utilstop_apiengine/src/routes/expense-management/expenseTemplates.js.
//
//   STANDARD    the original generic layout (default)
//   BLUE_DREAM  "BLUE DREAM AUTO MANT abu dhabi.xlsx": SR NO, JOB SCHEDULE DATE,
//               VIN NUMBER, MODEL, CLASSIFICATION, AMOUNT, VAT, NET AMOUNT.
//               AMOUNT is before VAT; NET AMOUNT is the VAT-inclusive figure.
//   JC_ALQURE   "JC-Alqure-template.xlsx": S No, Date, Description, Vehicle
//               number, Model, Price, Qty, VAT, Total. The vehicle number is
//               stored in vin_number.
export const STANDARD = "STANDARD";
export const BLUE_DREAM = "BLUE_DREAM";
export const JC_ALQURE = "JC_ALQURE";

export const TEMPLATE_OPTIONS = [
  { value: STANDARD, label: "Standard" },
  { value: BLUE_DREAM, label: "Blue Dream Auto Maint (Abu Dhabi)" },
  { value: JC_ALQURE, label: "Job card (Al Quze, JBL)" },
];

export const resolveTemplate = (key) => (TEMPLATE_OPTIONS.some((t) => t.value === key) ? key : STANDARD);

// Header text of each template's spreadsheet, exactly as the customer's file
// writes it. Also drives the "Expected columns" hint and the downloadable sample.
export const TEMPLATE_HEADERS = {
  STANDARD: [
    "JOB SCHEDULE DATE", "TRUCKING DATE", "VIN NUMBER", "MODEL", "CLASSIFICATION",
    "WASHING", "POLISHING", "PDI", "VALETING", "NET AMOUNT", "VAT", "Total AMOUNT",
  ],
  BLUE_DREAM: ["SR NO", "JOB SCHEDULE DATE", "VIN NUMBER", "MODEL", "CLASSIFICATION", "AMOUNT", "VAT", "NET AMOUNT"],
  JC_ALQURE: ["S No", "Date", "Description", "Vehicle number", "Model", "Price", "Qty", "VAT", "Total"],
};

const money = (v) => (Number.isFinite(Number(v)) ? Number(v).toFixed(2) : "0.00");
const qtyText = (v) => (Number.isFinite(Number(v)) ? String(Number(Number(v).toFixed(2))) : "1");

// Columns of the grid and of the upload preview for the non-STANDARD
// templates (STANDARD keeps its original hard-coded columns). Each `get` reads
// fields present on both a parsed sheet row and a saved entry.
const DATE = { get: (r) => formatDateHyphenated(r.job_schedule_date), nowrap: true };
const dash = (v) => v || "—";

export const TEMPLATE_COLUMNS = {
  BLUE_DREAM: [
    { label: "Job Date", ...DATE },
    { label: "VIN", get: (r) => dash(r.vin_number), bold: true },
    { label: "Model", get: (r) => dash(r.model) },
    { label: "Classification", get: (r) => dash(r.classification) },
    { label: "Amount", get: (r) => money(r.net_amount) },
    { label: "VAT", get: (r) => `${Number(r.vat_pct)}%` },
    { label: "Net Amount", get: (r) => money(r.total_amount), bold: true },
  ],
  JC_ALQURE: [
    { label: "Date", ...DATE },
    { label: "Description", get: (r) => dash(r.description) },
    { label: "Vehicle No", get: (r) => dash(r.vin_number), bold: true },
    { label: "Model", get: (r) => dash(r.model) },
    { label: "Price", get: (r) => money(r.unit_price ?? r.net_amount) },
    { label: "Qty", get: (r) => qtyText(r.qty) },
    { label: "VAT", get: (r) => `${Number(r.vat_pct)}%` },
    { label: "Total", get: (r) => money(r.total_amount), bold: true },
  ],
};
